module.exports = __webpack_public_path__ + "media/images/profile-missing-thumb-33cbf01baa79e532a3dad21596b261331651802fe4ec2afaa12ae59a8b5772f1.jpg";